/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import { core } from '@tock/coretypes';

export function getDiner(purchase?: {
  dinerPatron?: core.IPatron[] | null | undefined;
}): core.Patron {
  if (!purchase) {
    return null as any;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return _.first(purchase.dinerPatron)! as core.Patron;
}

export function getCreator(purchase: core.PurchaseOrder | core.PastPurchase): core.Patron {
  if (!purchase) {
    return null as any;
  }
  return (purchase as any)?.createdBy ?? null;
}
